import { React } from "react";
import { IncompleteType } from "@prestosports/prestostats-core/Tennis";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import IncompleteButtonGroupStyles from "../styles/IncompleteButtonGroup.styles";
import { useTeamsContext } from "../../../state/teams/context";

const IncompleteButtonGroup = ({ home, away, toggleIncompleteType }) => {
	const classes = IncompleteButtonGroupStyles();
	const { state: teamState } = useTeamsContext();
	const homeTeam = teamState.homeTeam();
	const awayTeam = teamState.awayTeam();

	const mappedTeams = [
		{
			teamKey: "away",
			teamName: awayTeam.teamName,
			incompleteType: away.incompleteType
		},
		{
			teamKey: "home",
			teamName: homeTeam.teamName,
			incompleteType: home.incompleteType
		}
	];

	return (
		<Grid spacing={1} className={classes.gridContainer} container>
			{mappedTeams.map(({ teamKey, teamName, incompleteType }) => {
				return (
					<Grid item>
						<FormControl>
							<FormControlLabel
								className={classes.formControlLabel}
								labelPlacement="top"
								control={
									<ToggleButtonGroup exclusive size="small" value={incompleteType?.code}>
										{Object.values(IncompleteType).map((type) => {
											return (
												<ToggleButton
													onClick={() => toggleIncompleteType(type, teamKey)}
													value={type.code}
													id={`${teamKey}-${type.code}`}
												>
													{type.name}
												</ToggleButton>
											);
										})}
									</ToggleButtonGroup>
								}
								label={teamName}
							/>
						</FormControl>
					</Grid>
				);
			})}
		</Grid>
	);
};

export default IncompleteButtonGroup;
